import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading as HeadingTitle } from "../components/misc/Headings";
import { ReactComponent as SvgDotPatternIcon } from "../images/dot-pattern.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-4`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-blue-800 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,
  textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between gap-4`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-40 mt-6 py-3 bg-gray-100 text-black rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300  hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 mx-12 mb-4 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`;
const initialData = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

export default () => {
  const [entity, setEntity] = React.useState(initialData);

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setEntity({ ...entity, [name]: value });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
      if (!entity.name) {
      alert("Please enter your name");
    } else if (!entity.email) {
      alert("Please enter your email address");
    } else if (!entity.subject) {
      alert("Please enter subject");
    } else if (!entity.message) {
      alert("Please enter your message");
    }else{
      try {
        // Create a FormData object to hold the form data
        const formData = new FormData(event.target);
        formData.append("access_key", "ae04df60-040f-4927-baa8-613e57945510");

        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData
        });

        const data = await response.json();
        if (data.success) {
          alert("Thank you! We'll get back to you soon.. ");
          setEntity(initialData);
        } else {
            alert("Please try after some time.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Network issue!, please try after some time.");
      }
    }
  };

  return (
    <Container>
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl">
            <HeadingTitle tw="text-5xl font-black tracking-wide text-center">
              Contact Us
            </HeadingTitle>
            <form onSubmit={onSubmit}>
              <TwoColumn>
                <Column tw="sm:w-full">
                  <InputContainer>
                    <Label htmlFor="name-input">Your Name</Label>
                    <Input
                      id="name-input"
                      type="text"
                      autoComplete="name"
                      placeholder="E.g. John Doe"
                      name="name"
                      value={entity.name}
                      onChange={onChangeInput}
                    />
                  </InputContainer>
                  <InputContainer>
                    <Label htmlFor="email-input">Your Email Address</Label>
                    <Input
                      id="email-input"
                      type="email"
                      autoComplete="email"
                      name="email"
                      value={entity.email}
                      placeholder="E.g. john@mail.com"
                      onChange={onChangeInput}
                    />
                    <InputContainer>
                      <Label htmlFor="name-input">Subject</Label>
                      <Input
                        id="subject-input"
                        type="text"
                        autoComplete="subject"
                        name="subject"
                        value={entity.subject}
                        placeholder="Enter Your Subject"
                        onChange={onChangeInput}
                      />
                    </InputContainer>
                  </InputContainer>
                  <InputContainer>
                    <Label htmlFor="message-input">Your Message</Label>
                    <TextArea
                      id="message-input"
                      name="message"
                      value={entity.message}
                      placeholder="E.g. Details about your message"
                      onChange={onChangeInput}
                    />
                  </InputContainer>
                  <SubmitButton type="submit">
                    Send Message
                  </SubmitButton>
                </Column>
              </TwoColumn>
            </form>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
